import { render } from "./StepForm.vue?vue&type=template&id=d185fc20&ts=true"
import script from "./StepForm.vue?vue&type=script&lang=ts"
export * from "./StepForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Surveys/Admin/StepForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d185fc20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d185fc20', __exports__)) {
    api.reload('d185fc20', __exports__)
  }
  
  module.hot.accept("./StepForm.vue?vue&type=template&id=d185fc20&ts=true", () => {
    api.rerender('d185fc20', render)
  })

}


export default __exports__